// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";
// import "./CDSReport.css";
// import { useNavigate } from "react-router-dom";
// import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";

// const API_URL = "https://payyug.in/api";

// const CDSReport = () => {
//   const navigate=useNavigate();
//   // ---- Filter data sources ----
//   const [centers, setCenters] = useState([]);
//   const [groups, setGroups] = useState([]);

//   // ---- Filter selections ----
//   const [loanType, setLoanType] = useState("");
//   const [selectedCenter, setSelectedCenter] = useState(null);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [filterType, setFilterType] = useState("All");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   // ---- Report data ----
//   const [reportRows, setReportRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [company, setCompany] = useState(null);

//   // ---- Table controls ----
//   const [searchTerm, setSearchTerm] = useState("");
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);

//   // Cascade rules: Center unlocks once a Loan Type is picked.
//   // Group unlocks once a Center is picked.
//   const isCenterDisabled = loanType === "";
//   const isGroupDisabled = !selectedCenter;

//   // Load all centers once
//   useEffect(() => {
//     const fetchCenters = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/group/centre`, {
//           params: { superAdminId: localStorage.getItem("adminuserId"), limit: 100000 },
//         });
//         setCenters(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchCenters();
//   }, []);

//   // Load groups whenever a center is picked
//   useEffect(() => {
//     if (!selectedCenter) {
//       setGroups([]);
//       setSelectedGroup(null);
//       return;
//     }
//     const fetchGroups = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/groupupdate/getall`, {
//           params: {
//             superAdminId: localStorage.getItem("adminuserId"),
//             CenterId:
//               selectedCenter.id === "all" ? "" : selectedCenter.id || "",
//             limit: 100000,
//           },
//         });
//         setGroups(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchGroups();
//   }, [selectedCenter]);

//   // Load company info (for the PDF logo)
//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");
//         if (!superAdminId) return;
//         const resp = await axios.get(`${API_URL}/get-company`, { params: { superAdminId } });
//         const data = resp.data || null;
//         if (data && data.logo) {
//           data.logoUrl = data.logo.startsWith("http")
//             ? data.logo
//             : `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//         }
//         setCompany(data);
//       } catch (err) {
//         console.error("Failed to fetch company", err);
//       }
//     };
//     fetchCompany();
//   }, []);

//   const fetchReportData = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${API_URL}/group-loan/emi/list-filter`, {
//         params: {
//           superAdminId: localStorage.getItem("adminuserId"),
//           centerId:
//             selectedCenter?.id === "all" ? "" : selectedCenter?.id || "",
//           groupId:
//             selectedGroup?.id === "all" ? "" : selectedGroup?.id || "",
//           fromDate: fromDate || "",
//           toDate: toDate || "",
//           loanType: loanType === "All" ? "" : loanType,
//           filterType: filterType === "All" ? "" : filterType,
//           page: 1,
//           limit: 1000,
//         },
//       });
//       setReportRows(res.data?.data || []);
//       setCurrentPage(1);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     fetchReportData();
//   };

//   const getGroupName = (row) =>
//     row.loanAccount?.groupName ||
//     row.loanAccount?.groupname ||
//     row.groupName ||
//     row.groupname ||
//     row.group_name ||
//     "N/A";

//   const getClientName = (row) =>
//     row.loanAccount?.memberName ||
//     row.loanAccount?.clientname ||
//     row.clientName ||
//     row.memberName ||
//     row.membername ||
//     "N/A";

//   const getRelationshipName = (row) =>
//     row.member?.guardianName ||
//     row.fatherName ||
//     row.husbandName ||
//     "N/A";

//   const getAccountNumber = (row) =>
//     row.loanAccount?.loanAccountNumber ||
//     row.loanAccount?.loanAccountNo ||
//     row.loanAccount?.accountNo ||
//     row.accountNo ||
//     row.accountNumber ||
//     "N/A";

//   const handleLoanTypeChange = (e) => {
//     setLoanType(e.target.value);
//     setSelectedCenter(null);
//     setSelectedGroup(null);
//   };

//   const handleCenterChange = (e) => {
//     const val = e.target.value;
//     if (val === "") setSelectedCenter(null);
//     else if (val === "all") setSelectedCenter({ id: "all", CenterName: "All" });
//     else setSelectedCenter(centers.find((c) => c.id === Number(val)) || null);
//     setSelectedGroup(null);
//   };

//   const handleGroupChange = (e) => {
//     const val = e.target.value;
//     if (val === "") setSelectedGroup(null);
//     else if (val === "all") setSelectedGroup({ id: "all", groupname: "All" });
//     else setSelectedGroup(groups.find((g) => g.id === Number(val)) || null);
//   };

//   const handleDownloadPDF = async () => {
//     const doc = new jsPDF("l", "mm", "a4");
//     const pageWidth = doc.internal.pageSize.width;
//     const pageHeight = doc.internal.pageSize.height;

//     // Company info shown top-right of every page. Adjust the field names below
//     // if your /get-company response uses different keys.
//     const companyName = company?.companyName || company?.name || "COMPANY NAME";
//     const cin = company?.cin || "-";
//     const regdOffice = company?.regdOffice || company?.address || "-";
//     const contact = company?.contact || company?.phone || "-";
//     const email = company?.email || "-";

//     // Branch / Village / Loan Officer aren't tracked as filters on this screen,
//     // so these fall back to whatever the selected center record carries.
//     const branchName = selectedCenter?.name || selectedCenter?.Branch || "";
//     const villageName = selectedCenter?.city || selectedCenter?.Village || "";
//     const hostname = window.location.hostname.split(".")[0];
//     const loanOfficerName = hostname==="bhavikamfi"?"Suresh Kumar Saini" : "";
//     const centerName = selectedCenter?.CenterName || "";

//     // Pre-fetch the logo once so it can be reused on both pages
//     let logoDataUrl = null;
//     if (company?.logoUrl) {
//       try {
//         const resp = await fetch(company.logoUrl);
//         if (resp.ok) {
//           const blob = await resp.blob();
//           logoDataUrl = await new Promise((res, rej) => {
//             const reader = new FileReader();
//             reader.onload = () => res(reader.result);
//             reader.onerror = rej;
//             reader.readAsDataURL(blob);
//           });
//         }
//       } catch (err) {
//         console.warn("Logo fetch failed", err);
//       }
//     }

//     // Draws the shared header + branch/center info block on the current page.
//     // Returns the Y position where page content can safely start.
//     const drawHeader = () => {
//       if (logoDataUrl) {
//         try {
//           doc.addImage(logoDataUrl, "PNG", 14, 8, 14, 14);
//         } catch (e) {
//           // ignore malformed image
//         }
//       }

//       doc.setFont("helvetica", "bold");
//       doc.setFontSize(15);
//       doc.text("CENTER DEMAND SHEET", pageWidth / 2, 18, { align: "center" });

//       const rightEdge = pageWidth - 14;
//       doc.setFont("helvetica", "bold");
//       doc.setFontSize(11);
//       doc.text(companyName, rightEdge, 14, { align: "right" });
//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(8);
//       doc.text(`CIN: ${cin}`, rightEdge, 19, { align: "right" });
//       doc.text(`Regd. Office: ${regdOffice}`, rightEdge, 23, { align: "right" });
//       doc.text(`Contact: ${contact}`, rightEdge, 27, { align: "right" });
//       doc.text(`Email: ${email}`, rightEdge, 31, { align: "right" });

//       let rowY = 42;
//       doc.setFontSize(10);
//       doc.setFont("helvetica", "bold");
//       doc.text("Branch", 14, rowY);
//       doc.setFont("helvetica", "normal");
//       doc.text(`: ${branchName}`, 34, rowY);
//       doc.setFont("helvetica", "bold");
//       doc.text("Village", pageWidth / 2 + 20, rowY);
//       doc.setFont("helvetica", "normal");
//       doc.text(`: ${villageName}`, pageWidth / 2 + 42, rowY);

//       rowY += 8;
//       doc.setFont("helvetica", "bold");
//       doc.text("Center Name", 14, rowY);
//       doc.setFont("helvetica", "normal");
//       doc.text(`: ${centerName}`, 40, rowY);
//       doc.setFont("helvetica", "bold");
//       doc.text("Loan Officer", pageWidth / 2 + 20, rowY);
//       doc.setFont("helvetica", "normal");
//       doc.text(`: ${loanOfficerName}`, pageWidth / 2 + 48, rowY);

//       return rowY + 10;
//     };

//     const drawFooter = (label) => {
//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(9);
//       doc.text(label, pageWidth / 2, pageHeight - 10, { align: "center" });
//     };

//     // ---------- PAGE 1: table ----------
//     const contentStartY = drawHeader();

//     const tableColumn = [
//       "Sl.No", "Group Name", "Due Date", "Client Name", "Relationship Name",
//       "Account No.", "Inst. No.", "O/S", "EMI", "OverDue Amount", "Adv Amount",
//       "Total Collection", "Client\nSign",
//     ];

//     const tableRows = paginatedRows.map((row, idx) => [
//       idx + 1,
//       getGroupName(row),
//       row.dueDate ? new Date(row.dueDate).toLocaleDateString("en-GB") : "-",
//       getClientName(row),
//       getRelationshipName(row),
//       getAccountNumber(row),
//       row.installmentNo ?? "-",
//       row.outstanding ?? "-",
//       row.emiAmount ?? "-",
//       row.overDueAmount ?? "-",
//       row.advanceAmount || "",
//       row.totalCollection || "",
//       "",
//     ]);

//     const totalOS = paginatedRows.reduce((s, r) => s + Number(r.outstanding || 0), 0);
//     const totalEMI = paginatedRows.reduce((s, r) => s + Number(r.emiAmount || 0), 0);

//     const rowsPerPage = 10;
//     const rowChunks = [];
//     for (let i = 0; i < tableRows.length; i += rowsPerPage) {
//       rowChunks.push(tableRows.slice(i, i + rowsPerPage));
//     }

//     rowChunks.forEach((chunk, chunkIndex) => {
//       if (chunkIndex > 0) {
//         doc.addPage();
//       }
//       const contentY = chunkIndex === 0 ? contentStartY : drawHeader();

//       autoTable(doc, {
//         startY: contentY,
//         margin: { left: 12, right: 12, bottom: 18 },
//         tableWidth: pageWidth - 24,
//         showHead: "everyPage",
//         head: [tableColumn],
//         body: chunk,
//         foot: chunkIndex === rowChunks.length - 1 ? [[
//           { content: "Center Totals:", colSpan: 7, styles: { halign: "right", fontStyle: "bold" } },
//           { content: totalOS.toFixed(2), styles: { fontStyle: "bold" } },
//           { content: totalEMI.toFixed(2), styles: { fontStyle: "bold" } },
//           "", "", "", "",
//         ]] : [],
//         theme: "grid",
//         headStyles: {
//           fillColor: [235, 238, 242],
//           textColor: [20, 20, 20],
//           fontStyle: "bold",
//           fontSize: 8,
//           lineColor: [0, 0, 0],
//           lineWidth: 0.1,
//           halign: "center",
//         },
//         footStyles: {
//           fillColor: [255, 255, 255],
//           textColor: [0, 0, 0],
//           lineColor: [0, 0, 0],
//           lineWidth: 0.1,
//           fontSize: 8,
//         },
//         bodyStyles: {
//           minCellHeight: 8,
//           valign: "middle",
//           fontSize: 7.4,
//           textColor: [20, 20, 20],
//         },
//         styles: {
//           fontSize: 7.4,
//           cellPadding: 2.5,
//           halign: "center",
//           valign: "middle",
//           lineColor: [0, 0, 0],
//           lineWidth: 0.1,
//           overflow: "linebreak",
//         },
//         columnStyles: {
//           0: { halign: "center", cellWidth: 9 },
//           1: { halign: "left", cellWidth: 26, overflow: "linebreak" },
//           2: { halign: "center", cellWidth: 18 },
//           3: { halign: "left", cellWidth: 34, overflow: "linebreak" },
//           4: { halign: "left", cellWidth: 24, overflow: "linebreak" },
//           5: { halign: "left", cellWidth: 40, overflow: "ellipsize", fontSize: 7 },
//           6: { halign: "center", cellWidth: 10 },
//           7: { halign: "right", cellWidth: 20 },
//           8: { halign: "right", cellWidth: 20 },
//           9: { halign: "right", cellWidth: 20 },
//           10: { halign: "right", cellWidth: 20 },
//           11: { halign: "right", cellWidth: 22 },
//           12: { halign: "center", cellWidth: 18, overflow: "linebreak" },
//         },
//         didDrawPage: () => {
//           const pageNumber = doc.internal.getNumberOfPages();
//           doc.setFont("helvetica", "normal");
//           doc.setFontSize(8);
//           doc.text(`Page ${pageNumber}`, pageWidth - 12, pageHeight - 10, { align: "right" });
//         },
//       });
//     });

//     // ---------- PAGE 2: center meeting form + denomination sheet ----------
//     doc.addPage();
//     const p2StartY = drawHeader();

//     const leftX = 14;
//     const boxWidth = 118;
//     const rightX = leftX + boxWidth + 8;

//     // Box 1: CM conduct details
//     let y = p2StartY;
//     doc.setDrawColor(0);
//     doc.setLineWidth(0.2);
//     doc.rect(leftX, y, boxWidth, 18);
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(9);
//     doc.text("CM Conduct Date: ________________CM Start Time: _________ CM End Time: _________", leftX + 3, y + 7);
//     doc.text("Total Members in center: _________        Members Present: _________", leftX + 3, y + 14);

//     // Box 2: LO details
//     y += 18 + 4;
//     doc.rect(leftX, y, boxWidth, 14);
//     doc.text("LO Name & Emp Id : N/A", leftX + 3, y + 6);
//     doc.text("Remark if any : ____________________________________________", leftX + 3, y + 12);

//     // Box 3: Visitor details
//     y += 14 + 4;
//     doc.rect(leftX, y, boxWidth, 22);
//     doc.text("Visitor's Name & Emp Id : _____________________  Department: ___________", leftX + 3, y + 6);
//     doc.text("Remark if any : ____________________________________________", leftX + 3, y + 12);
//     doc.text("Signature : _______________________", leftX + 3, y + 18);

//     const boxesBottomY = y + 22;

//     // Right side: denomination table
//     autoTable(doc, {
//       startY: p2StartY,
//       margin: { left: rightX },
//       tableWidth: pageWidth - 14 - rightX,
//       head: [["Denomination", "Amount"]],
//       body: [
//         ["2000 X", ""], ["500 X", ""], ["200 X", ""], ["100 X", ""],
//         ["50 X", ""], ["20 X", ""], ["10 X", ""], ["5 X", ""],
//         ["Coins", "(If any)"], ["Total", "Rupees:"],
//       ],
//       theme: "grid",
//       headStyles: { fillColor: [235, 238, 242], textColor: [20, 20, 20], fontStyle: "bold", lineColor: [0, 0, 0], lineWidth: 0.1, halign: "center" },
//       styles: { fontSize: 9, cellPadding: 3, lineColor: [0, 0, 0], lineWidth: 0.1, halign: "right" },
//       columnStyles: { 0: { halign: "right", fontStyle: "bold" } },
//     });

//     const denomBottomY = doc.lastAutoTable?.finalY || p2StartY;
//     let cursorY = Math.max(boxesBottomY, denomBottomY) + 12;

//     // Declaration
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(9);
//     doc.text("Center Leader Declaration:", leftX, cursorY);
//     doc.setFont("helvetica", "normal");
//     const declarationText =
//       "I hereby confirm that the recorded information related to our loan repayment and saving is true and we have handed over the required amount to loan officer.";
//     const declarationLines = doc.splitTextToSize(declarationText, pageWidth - 14 - (leftX + 52));
//     doc.text(declarationLines, leftX + 52, cursorY);

//     cursorY += 14;
//     doc.setFont("helvetica", "bold");
//     doc.text("Signature of Center Leader : _____________________", leftX, cursorY);
//     doc.text("Signature of Loan Officer : _____________________", pageWidth / 2 + 5, cursorY);

//     cursorY += 10;
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(8);
//     const disclaimerText =
//       "Disclaimer: - In case of Branch deposit by Member/Center Leader the responsibility of depositing the collection safely at branch lies solely with concerned member/Center leader. They must ensure that the CDS copy received has Branch Stamp on it after they deposit the collection in Branch.";
//     const disclaimerLines = doc.splitTextToSize(disclaimerText, pageWidth - 28);
//     doc.text(disclaimerLines, leftX, cursorY);

//     cursorY += disclaimerLines.length * 4 + 8;
//     doc.setFont("helvetica", "italic");
//     doc.text("Please keep this copy as a proof of your repayment towards loan & savings", leftX, cursorY);

//     drawFooter(`Page ${doc.internal.getNumberOfPages()}`);

//     doc.save("CDS_Report.pdf");
//   };

//   const handleDownloadExcel = () => {
//     if (!paginatedRows.length) {
//       return;
//     }

//     const excelRows = paginatedRows.map((row, index) => ({
//       "Sl.No": index + 1,
//       "Group Name": getGroupName(row),
//       "Due Date": row.dueDate
//         ? new Date(row.dueDate).toLocaleDateString("en-GB")
//         : "-",
//       "Client Name": getClientName(row),
//       "Relationship Name": getRelationshipName(row),
//       "Account No.": getAccountNumber(row),
//       "Installment No.": row.installmentNo ?? "-",
//       Outstanding: Number(row.outstanding || 0),
//       "EMI Amount": Number(row.emiAmount || 0),
//       "OverDue Amount": Number(row.overDueAmount || 0),
//       "Adv Amount": Number(row.advanceAmount || 0),
//       "Total Collection": Number(row.totalCollection || 0),
//     }));

//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.json_to_sheet(excelRows);
//     XLSX.utils.book_append_sheet(workbook, worksheet, "CDS Report");
//     XLSX.writeFile(workbook, "CDS_Report.xlsx");
//   };

//   const filteredRows = reportRows.filter((row) => {
//     const q = searchTerm.toLowerCase();
//     return (
//       getGroupName(row).toLowerCase().includes(q) ||
//       getClientName(row).toLowerCase().includes(q) ||
//       getAccountNumber(row).toLowerCase().includes(q)
//     );
//   });

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, itemsPerPage]);

//   const totalPages = Math.max(1, Math.ceil(filteredRows.length / itemsPerPage));
//   const safeCurrentPage = Math.min(currentPage, totalPages);
//   const startIndex = (safeCurrentPage - 1) * itemsPerPage;
//   const paginatedRows = filteredRows.slice(startIndex, startIndex + itemsPerPage);

//   const handlePrevPage = () => setCurrentPage((p) => Math.max(1, p - 1));
//   const handleNextPage = () => setCurrentPage((p) => Math.min(totalPages, p + 1));

//   return (
//     <div className="cds-page">
//       {/* Back wrapper */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           padding: "8px 16px",
//           backgroundColor: "#fff",
//           border: "1px solid #e0e0e0",
//           borderRadius: "8px",
//           margin: "20px 0",
//           boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//         }}
//       >
//         <ArrowLeftIcon
//           onClick={() => navigate(-1)}
//           style={{
//             cursor: "pointer",
//             padding: "4px",
//             borderRadius: "4px",
//             transition: "background-color 0.2s",
//           }}
//           onMouseEnter={(e) =>
//             (e.currentTarget.style.backgroundColor = "#f5f5f5")
//           }
//           onMouseLeave={(e) =>
//             (e.currentTarget.style.backgroundColor = "transparent")
//           }
//         />

//         <h2
//           style={{
//             margin: 0,
//             fontSize: "18px",
//             fontWeight: "600",
//             color: "#333",
//           }}
//         >
//           Center Demand Sheet
//         </h2>

//         <ArrowRightIcon
//           onClick={() => navigate(1)}
//           style={{
//             cursor: "pointer",
//             padding: "4px",
//             borderRadius: "4px",
//             transition: "background-color 0.2s",
//           }}
//           onMouseEnter={(e) =>
//             (e.currentTarget.style.backgroundColor = "#f5f5f5")
//           }
//           onMouseLeave={(e) =>
//             (e.currentTarget.style.backgroundColor = "transparent")
//           }
//         />
//       </div>

//       <section className="cds-filter-panel">
//         <span className="cds-filter-panel-label">Filter By</span>

//         <form className="cds-filter-form" onSubmit={handleSubmit}>
//           <div className="cds-filter-grid">
//             <div className="cds-field">
//               <label>Loan Type</label>
//               <select value={loanType} onChange={handleLoanTypeChange}>
//                 <option value="">Select Type</option>
//                 <option value="All">All</option>
//                 <option value="FIXED">Fixed Loan</option>
//                 <option value="INDIVIDUAL">Individual</option>
//               </select>
//             </div>

//             <div className="cds-field">
//               <label>Select Center</label>
//               <select value={selectedCenter?.id ?? ""} disabled={isCenterDisabled} onChange={handleCenterChange}>
//                 <option value="">Select Center</option>
//                 <option value="all">All</option>
//                 {centers.map((c) => (
//                   <option key={c.id} value={c.id}>{c.CenterName}</option>
//                 ))}
//               </select>
//             </div>

//             <div className="cds-field">
//               <label>Select Group</label>
//               <select value={selectedGroup?.id ?? ""} disabled={isGroupDisabled} onChange={handleGroupChange}>
//                 <option value="">Select Group</option>
//                 <option value="all">All</option>
//                 {groups.map((g) => (
//                   <option key={g.id} value={g.id}>{g.groupname}</option>
//                 ))}
//               </select>
//             </div>

//             <div className="cds-field">
//               <label>Select Filter</label>
//               <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
//                 <option value="All">All</option>
//                 <option value="pending">Pending</option>
//                 <option value="overdue">Overdue</option>
//               </select>
//             </div>

//             <div className="cds-field">
//               <label>From Date</label>
//               <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//             </div>

//             <div className="cds-field">
//               <label>To Date</label>
//               <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
//             </div>
//           </div>

//           <div className="cds-submit-row">
//             <button type="submit" className="cds-btn-submit">submit</button>
//           </div>
//         </form>
//       </section>

//       <div className="cds-download-row">
//         <button className="cds-btn-download" onClick={handleDownloadPDF}>
//           ⬇ Download PDF
//         </button>
//         <button className="cds-btn-download cds-btn-download-excel" onClick={handleDownloadExcel}>
//           ⬇ Download Excel
//         </button>
//       </div>

//       <section className="cds-table-panel">
//         <div className="cds-table-toolbar">
//           <div className="cds-search">
//             <input
//               type="text"
//               placeholder="Search..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>
//           <div className="cds-entries">
//             <span>Show</span>
//             <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))}>
//               <option value={10}>10</option>
//               <option value={25}>25</option>
//               <option value={50}>50</option>
//               <option value={100}>100</option>
//             </select>
//             <span>entries</span>
//           </div>
//         </div>

//         <div className="cds-table-scroll">
//           <table className="cds-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Group Name</th>
//                 <th>Due Date</th>
//                 <th>Client Name</th>
//                 <th>Relationship Name</th>
//                 <th>Account No.</th>
//                 <th>Installment No.</th>
//                 <th>Outstanding</th>
//                 <th>EMI Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr><td colSpan={9} className="cds-empty-cell">Loading...</td></tr>
//               ) : paginatedRows.length === 0 ? (
//                 <tr><td colSpan={9} className="cds-empty-cell">No data available</td></tr>
//               ) : (
//                 paginatedRows.map((row, idx) => (
//                   <tr key={row.id || idx}>
//                     <td>{startIndex + idx + 1}</td>
//                     <td>{getGroupName(row)}</td>
//                     <td>{row.dueDate ? new Date(row.dueDate).toLocaleDateString("en-GB") : "-"}</td>
//                     <td>{getClientName(row)}</td>
//                     <td>{getRelationshipName(row)}</td>
//                     <td>{getAccountNumber(row)}</td>
//                     <td>{row.installmentNo || "-"}</td>
//                     <td>₹{row.outstanding ? Number(row.outstanding).toLocaleString() : "-"}</td>
//                     <td>₹{row.emiAmount ? Number(row.emiAmount).toLocaleString() : "-"}</td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         <div className="cds-pagination">
//           <div className="cds-pagination-info">
//             {filteredRows.length === 0
//               ? "Showing 0 entries"
//               : `Showing ${startIndex + 1} to ${Math.min(startIndex + itemsPerPage, filteredRows.length)} of ${filteredRows.length} entries`}
//           </div>
//           <div className="cds-pagination-buttons">
//             <button className="cds-btn-page" onClick={handlePrevPage} disabled={safeCurrentPage === 1}>
//               Previous
//             </button>
//             <span className="cds-pagination-current">Page {safeCurrentPage} of {totalPages}</span>
//             <button className="cds-btn-page" onClick={handleNextPage} disabled={safeCurrentPage === totalPages}>
//               Next
//             </button>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default CDSReport;




import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ArrowLeftIcon, ArrowRightIcon, Download } from "lucide-react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./CDSReport.css";

const API_URL = "https://payyug.in/api";
const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100, "All"];

const CDSReport = () => {
  const navigate = useNavigate();
  const superAdminId = Number(localStorage.getItem("adminuserId"));

  /* ---------------- STATES ---------------- */
  const [branches, setBranches] = useState([]);
  const [centers, setCenters] = useState([]);
  const [groups, setGroups] = useState([]);
  
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [dayFilter, setDayFilter] = useState("");
  const [loanTypeFilter, setLoanTypeFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [emiData, setEmiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [company, setCompany] = useState(null);

  const hostname = window.location.hostname.split(".")[0];
  const companyName = company?.name || "Company";

  // Memoized dynamic headers
  const selectedCenterName = useMemo(() => {
    return centers.find((c) => String(c.id) === String(selectedCenter))?.CenterName || "";
  }, [centers, selectedCenter]);

  const selectedCenterAddress = useMemo(() => {
    return centers.find((c) => String(c.id) === String(selectedCenter))?.city || "";
  }, [centers, selectedCenter]);

  /* ---------------- SEARCH / FILTER DATA MATCHING ---------------- */
  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) return emiData;
    const target = searchQuery.toLowerCase();
    return emiData.filter((r) => {
      return (
        r.loanAccount?.loanAccountNumber?.toLowerCase().includes(target) ||
        r.loanAccount?.memberName?.toLowerCase().includes(target) ||
        r.loanAccount?.centerName?.toLowerCase().includes(target) ||
        r.loanAccount?.groupName?.toLowerCase().includes(target)
      );
    });
  }, [emiData, searchQuery]);

  /* ---------------- CUMULATIVE OVERDUE CALCULATION ---------------- */
  const calculateOverdueAmount = useCallback((currentRow) => {
    if (!currentRow?.loanAccount?.loanAccountNumber) return 0;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return filteredData.reduce((sum, r) => {
      if (r.loanAccount?.loanAccountNumber !== currentRow.loanAccount?.loanAccountNumber) {
        return sum;
      }
      if (!r.dueDate) return sum;

      const dueDate = new Date(r.dueDate);
      dueDate.setHours(0, 0, 0, 0);

      const statusClean = r.status?.toLowerCase();
      const isUnpaid = statusClean !== "paid" && statusClean !== "success" && statusClean !== "settled";
      
      if (dueDate < today && isUnpaid) {
        return sum + Number(r.emiAmount || 0);
      }
      return sum;
    }, 0);
  }, [filteredData]);

  /* ---------------- DATA FETCHING FUNCTIONS ---------------- */
  const fetchEmis = useCallback(async (page = 1) => {
    // FIX: Changed from 'if (superAdminId) return;' to block only when missing
    if (!superAdminId) return;

    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/group-loan/emi/list-filter`, {
        params: {
          superAdminId,
          branchId: selectedBranch || undefined,
          centerId: selectedCenter || undefined,
          groupId: selectedGroup || undefined,
          page,
          filterType: dayFilter || undefined,
          loanType: loanTypeFilter || undefined,
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
          search: searchQuery || undefined,
          limit: itemsPerPage === "All" ? 100000 : itemsPerPage,
        },
      });

      if (res.data?.success) {
        setEmiData(res.data.data || []);
        setCurrentPage(res.data.currentPage || page);
        setTotalPages(res.data.totalPages || 1);
        setTotalRecords(res.data.totalRecords || 0);
      } else {
        setEmiData([]);
        setTotalPages(1);
        setTotalRecords(0);
        toast.error(res.data.message || "No data found");
      }
    } catch (error) {
      console.error("EMI fetch error:", error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  }, [superAdminId, selectedBranch, selectedCenter, selectedGroup, dayFilter, loanTypeFilter, fromDate, toDate, itemsPerPage, searchQuery]);

  /* ---------------- USE EFFECTS ---------------- */
  
  // Fetch Branches
  useEffect(() => {
    if (!superAdminId) return;
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: { SuperAdminId: superAdminId, limit: "all" },
        });
        setBranches(res?.data?.branches || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load branches");
      }
    };
    fetchBranch();
  }, [superAdminId]);

  // Fetch Centers
  useEffect(() => {
    if (!superAdminId) return;
    const fetchCenters = async () => {
      try {
        const res = await axios.get(`${API_URL}/group/centre?superAdminId=${superAdminId}&branchid=${selectedBranch}&limit=10000`);
        setCenters(res.data?.data || []);
      } catch (error) {
        console.error("Center fetch error:", error);
      }
    };
    fetchCenters();
  }, [superAdminId,selectedBranch]);

  // Fetch Groups
  useEffect(() => {
    if (!superAdminId || !selectedCenter) {
      setGroups([]);
      return;
    }
    const fetchGroups = async () => {
      try {
        const res = await axios.get(`${API_URL}/groupupdate/getall?superAdminId=${superAdminId}&CenterId=${selectedCenter}&limit=10000`);
        setGroups(res.data?.data || []);
      } catch (error) {
        console.error("Group fetch error:", error);
      }
    };
    fetchGroups();
  }, [selectedCenter, superAdminId]);

  // Fetch Company Details
  useEffect(() => {
    if (!superAdminId) return;
    const fetchCompany = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-company?superAdminId=${superAdminId}`);
        if (res.status === 200 && res.data) {
          const data = res.data;
          if (data.logo) {
            data.logoUrl = `${API_URL.replace("/api", "")}/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details", err);
      }
    };
    fetchCompany();
  }, [superAdminId]);

  // Handle pagination changes automatically
  useEffect(() => {
    fetchEmis(currentPage);
  }, [currentPage, itemsPerPage, fetchEmis]);

  // Debounced Search logic
  useEffect(() => {
    if (!hasSearched) return;
    const delayDebounceFn = setTimeout(() => {
      setCurrentPage(1);
      fetchEmis(1);
    }, 400);
    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, fetchEmis, hasSearched]);

  const handleFilter = () => {
    setCurrentPage(1);
    fetchEmis(1);
  };

  const toDataURL = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  /* ---------------- PDF GENERATION ---------------- */
  const handleCdsDownload = async () => {
    const doc = new jsPDF("l", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    let logoBase64 = null;
    if (company?.logoUrl) {
      try {
        logoBase64 = await toDataURL(company.logoUrl);
      } catch (e) {
        console.error("Logo conversion error: ", e);
      }
    }

    const totalDueSum = filteredData.reduce(
      (acc, r) => acc + Number(String(r.emiAmount || 0).replace(/,/g, "")),
      0
    );

    const renderCdsHeader = (pdfDoc) => {
      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.setFontSize(14);
      pdfDoc.setTextColor(0, 0, 0);
      pdfDoc.text("CENTER DEMAND SHEET", pageWidth / 2, 35, { align: "center" });

      if (logoBase64) {
        pdfDoc.addImage(logoBase64, "PNG", 40, 15, 50, 50);
      }

      pdfDoc.setFontSize(14);
      pdfDoc.setTextColor(40, 40, 40);

      const splitCompanyName = pdfDoc.splitTextToSize(companyName.toUpperCase(), 250);
      pdfDoc.text(splitCompanyName, pageWidth - 40, 35, { align: "right" });

      const companyLinesCount = Array.isArray(splitCompanyName) ? splitCompanyName.length : 1;
      let detailsY = 35 + companyLinesCount * 15;

      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.setFontSize(8.5);
      pdfDoc.setTextColor(80, 80, 80);

      const lines = [
        `CIN: ${company?.cin || "-"}`,
        `Regd. Office: ${company?.address || "-"}`,
        `Contact: ${company?.contact || "-"}`,
        `Email: ${company?.email || "-"}`,
      ];

      lines.forEach((line) => {
        const splitText = pdfDoc.splitTextToSize(line, 250);
        pdfDoc.text(splitText, pageWidth - 40, detailsY, { align: "right" });
        detailsY += splitText.length * 11;
      });

      let currentY = detailsY + 20;
      pdfDoc.setFontSize(10);
      pdfDoc.setTextColor(0, 0, 0);

      const currentBranchObj = branches.find(b => String(b.id) === String(selectedBranch));
      const branchLabel = "Branch";
      const branchValue = `:  ${currentBranchObj?.name || "N/A"}`;
      const villageLabel = "Village";
      const villageValue = `:  ${selectedCenterAddress}`;

      const splitBranchVal = pdfDoc.splitTextToSize(branchValue, 280);
      const splitVillageVal = pdfDoc.splitTextToSize(villageValue, 250);

      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.text(branchLabel, 40, currentY);
      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.text(splitBranchVal, 120, currentY);

      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.text(villageLabel, 450, currentY);
      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.text(splitVillageVal, 530, currentY);

      const maxRow1Lines = Math.max(splitBranchVal.length, splitVillageVal.length);
      currentY += maxRow1Lines * 14 + 8;

      const centerLabel = "Center Name";
      const centerValue = `:  ${selectedCenterName}`;
      const officerLabel = "Loan Officer";
      const officerValue = `: ${hostname === "bhavikamfi" ? "Suresh Kumar Saini" : ""}  `;

      const splitCenterVal = pdfDoc.splitTextToSize(centerValue, 280);
      const splitOfficerVal = pdfDoc.splitTextToSize(officerValue, 250);

      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.text(centerLabel, 40, currentY);
      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.text(splitCenterVal, 120, currentY);

      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.text(officerLabel, 450, currentY);
      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.text(splitOfficerVal, 530, currentY);

      const maxRow2Lines = Math.max(splitCenterVal.length, splitOfficerVal.length);
      return currentY + maxRow2Lines * 14 + 15;
    };

    const firstPageTableStartY = renderCdsHeader(doc);

    const tableBody = filteredData.map((r, i) => {
      const overdueAmount = calculateOverdueAmount(r);
      return [
        i + 1,
        r.loanAccount?.groupName || "N/A",
        r.dueDate ? new Date(r.dueDate).toLocaleDateString("en-GB") : "N/A",
        r.loanAccount?.memberName || "N/A",
        r?.member?.fatherName || r?.member?.guardianName || r?.member?.husbandName || "N/A",
        r?.member?.mobileNumber || "N/A",
        r.loanAccount?.loanAccountNumber || "N/A",
        r.installmentNo || "N/A",
        r.outstanding ? `${r.outstanding}` : "0",
        r.emiAmount ? `${r.emiAmount}` : "0",
        overdueAmount,
        r.status || "N/A",
        "",
        "",
        "",
      ];
    });

    const totalsRow = [
      {
        content: "Center Totals:",
        colSpan: 9,
        styles: { halign: "right", fontStyle: "bold" },
      },
      { content: `${totalDueSum.toFixed(2)}`, styles: { fontStyle: "bold" } },
      { content: "", colSpan: 5 },
    ];
    tableBody.push(totalsRow);

    autoTable(doc, {
      startY: firstPageTableStartY,
      head: [
        [
          "S.No", "Group Name", "Due Date", "Client Name", "Relationship Name",
          "Mobile No", "Account No.", "Inst. No.", "O/S", "EMI",
          "Total Due Amount", "Status", "Adv Amount", "Total Collection", "Client Sign"
        ],
      ],
      body: tableBody,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 5,
        halign: "center",
        valign: "middle",
        textColor: 0,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontStyle: "bold",
        lineWidth: 0.5,
        lineColor: 150,
      },
      columnStyles: {
        1: { halign: "left" },
        3: { halign: "left" },
      },
      margin: { top: 35, bottom: 45 },
      pageBreak: "auto",
    });

    /* ================= SUMMARY SHEET ================= */
    doc.addPage([841.89, 595.28], "landscape");

    const summaryPageContentStartY = renderCdsHeader(doc);
    let startY = summaryPageContentStartY + 10;

    doc.rect(40, startY, 400, 60);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text("CM Conduct Date: ________________", 48, startY + 20);
    doc.text("CM Start Time: _________", 200, startY + 20);
    doc.text("CM End Time: _________", 320, startY + 20);
    doc.text("Total Members in center: _________", 48, startY + 45);
    doc.text("Members Present: _________", 240, startY + 45);

    doc.rect(40, startY + 70, 400, 40);
    doc.text(`LO Name & Emp Id : `, 48, startY + 85);
    doc.text("Remark if any : ____________________________________________________", 48, startY + 100);

    doc.rect(40, startY + 120, 400, 70);
    doc.text("Visitor's Name & Emp Id : _____________________  Department: ___________", 48, startY + 135);
    doc.text("Remark if any : ____________________________________________________", 48, startY + 155);
    doc.text("Signature : _______________________", 48, startY + 180);

    autoTable(doc, {
      startY: startY,
      margin: { left: 470 },
      tableWidth: 330,
      head: [["Denomination", "Amount"]],
      body: [
        ["2000 X", ""],
        ["500 X", ""],
        ["200 X", ""],
        ["100 X", ""],
        ["50 X", ""],
        ["20 X", ""],
        ["10 X", ""],
        ["5 X", ""],
        ["Coins", "(If any)"],
        ["Total", "Rupees:"],
      ],
      theme: "grid",
      styles: { fontSize: 8, cellPadding: 4, halign: "center" },
      headStyles: { fillColor: [245, 245, 245], textColor: 0, fontStyle: "bold" },
      columnStyles: { 0: { halign: "right", fontStyle: "bold", width: 150 } },
    });

    let footerY = startY + 230;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text("Center Leader Declaration:", 40, footerY);
    doc.setFont("helvetica", "normal");
    doc.text(
      "I hereby confirm that the recorded information related to our loan repayment and saving is true and we have handed over the required amount to loan officer.",
      165,
      footerY,
      { maxWidth: 630 }
    );

    doc.setFont("helvetica", "bold");
    doc.text("Signature of Center Leader : _____________________", 40, footerY + 45);
    doc.text("Signature of Loan Officer : _____________________", 480, footerY + 45);

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(
      "Disclaimer: - In case of Branch deposit by Member/Center Leader the responsibility of depositing the collection safely at branch lies solely with concerned member/Center leader.\nThey must ensure that the CDS copy received has Branch Stamp on it after they deposit the collection in Branch.",
      40,
      footerY + 80,
      { maxWidth: 760 }
    );

    doc.setFont("helvetica", "italic");
    doc.text("Please keep this copy as a proof of your repayment towards loan & savings", 40, footerY + 130);

    const totalPagesCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPagesCount; i++) {
      doc.setPage(i);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(50);
      doc.text(`Page ${i} of ${totalPagesCount}`, pageWidth / 2, pageHeight - 15, { align: "center" });
    }

    doc.save(`CDS_Report_${selectedCenterName || "Report"}.pdf`);
  };

  return (
    <div className="gledr-container">
      {/* Navigation Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer", padding: "4px", borderRadius: "4px" }}
        />
        <h2 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#333" }}>
          Center Demand Sheet
        </h2>
        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{ cursor: "pointer", padding: "4px", borderRadius: "4px" }}
        />
      </div>

      {/* FILTER PANEL */}
      <div className="gledr-filterBox">
        <div className="gledr-filter-title">Filter By</div>
        <div className="gledr-filter-wrapper">
          <div className="gledr-filter-item">
            <div className="gledr-filter">
              <label>Select Branch</label>
              <select
                value={selectedBranch}
                onChange={(e) => {
                  setSelectedBranch(e.target.value);
                  setSelectedCenter("");
                  setSelectedGroup("");
                }}
              >
                <option value="">All Branch</option>
                {branches.map((b) => (
                  <option key={b.id} value={b.id}>{b.name}</option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Center</label>
              <select
                value={selectedCenter}
                onChange={(e) => {
                  setSelectedCenter(e.target.value);
                  setSelectedGroup("");
                }}
                disabled={!selectedBranch}
              >
                <option value="">All Centers</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>{c.CenterName}</option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Group</label>
              <select
                value={selectedGroup}
                onChange={(e) => setSelectedGroup(e.target.value)}
                disabled={!selectedCenter}
              >
                <option value="">All Groups</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>{g.groupname}, {g.groupcode}</option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
              <label>Loan Type</label>
              <select value={loanTypeFilter} onChange={(e) => setLoanTypeFilter(e.target.value)}>
                <option value="">All Types</option>
                <option value="FIXED">Fixed Loan</option>
                <option value="INDIVIDUAL">Individual Loan</option>
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Filter</label>
              <select value={dayFilter} onChange={(e) => setDayFilter(e.target.value)}>
                <option value="">All</option>
                <option value="today">Today</option>
                <option value="tomorrow">Tomorrow</option>
                <option value="pending">Pending</option>
                <option value="overdue">Overdue</option>
              </select>
            </div>

            <div className="gledr-filter">
              <label>From Date</label>
              <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
            </div>

            <div className="gledr-filter">
              <label>To Date</label>
              <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
            </div>
          </div>

          <div className="gledr-filter-submit-btn">
            <button className="submit-btn" onClick={handleFilter}>submit</button>
          </div>
        </div>
      </div>

      {/* SINGLE CDS DOWNLOAD BUTTON */}
      {filteredData.length > 0 && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "15px" }}>
          <button
            onClick={handleCdsDownload}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#22c55e",
              color: "#ffffff",
              padding: "10px 20px",
              fontSize: "14px",
              fontWeight: "600",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <Download size={16} /> CDS Download
          </button>
        </div>
      )}

      {/* SEARCH + PER PAGE OPTIONS */}
      <div className="gledr-report-filter">
        <input
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
        <div className="gledr-report-filter-inputs">
          <label>Show </label>
          <select
            value={itemsPerPage}
            onChange={(e) => {
              const value = e.target.value;
              setItemsPerPage(value === "All" ? "All" : Number(value));
              setCurrentPage(1);
            }}
          >
            {ITEMS_PER_PAGE_OPTIONS.map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
          <span> entries</span>
        </div>
      </div>

      {/* DATA TABLE */}
      <div className="gledr-report-table-container">
        <table className="gledr-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Group Name</th>
              <th>Due Date</th>
              <th>Client Name</th>
              <th>Relationship Name</th>
              <th>Mobile No</th>
              <th>Account No.</th>
              <th>Installment No.</th>
              <th>Outstanding</th>
              <th>EMI Amount</th>
              <th>Total Due Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="12" align="center">Loading...</td>
              </tr>
            ) : filteredData.length ? (
              filteredData.map((r, i) => {
                const status = r.status?.toLowerCase() || "pending";
                return (
                  <tr key={r.id || i}>
                    <td>
                      {itemsPerPage === "All"
                        ? i + 1
                        : (currentPage - 1) * itemsPerPage + i + 1}
                    </td>
                    <td>{r.loanAccount?.groupName || "N/A"}</td>
                    <td>{r.dueDate ? new Date(r.dueDate).toLocaleDateString("en-GB") : "N/A"}</td>
                    <td>{r.loanAccount?.memberName || "N/A"}</td>
                    <td>{r?.member?.fatherName || r?.member?.guardianName || r?.member?.husbandName || "N/A"}</td>
                    <td>{r?.member?.mobileNumber || "N/A"}</td>
                    <td>{r.loanAccount?.loanAccountNumber || "N/A"}</td>
                    <td>{r.installmentNo || "N/A"}</td>
                    <td>₹{r.outstanding || 0}</td>
                    <td>₹{r.emiAmount || 0}</td>
                    <td>₹{calculateOverdueAmount(r)}</td>
                    <td
                      style={{ textTransform: "capitalize" }}
                    >
                      {status}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="12" align="center">No data found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION PANEL */}
      {itemsPerPage !== "All" && filteredData.length > 0 && (
        <div className="gledr-pagination">
          <button
            disabled={currentPage === 1 || filteredData.length === 0}
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          >
            ⬅ Prev
          </button>
          <span>{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            disabled={currentPage === totalPages || filteredData.length === 0}
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          >
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default CDSReport;